import { render } from "./studentAward.vue?vue&type=template&id=a1cd990c&scoped=true"
import script from "./studentAward.vue?vue&type=script&lang=js"
export * from "./studentAward.vue?vue&type=script&lang=js"

import "./studentAward.vue?vue&type=style&index=0&id=a1cd990c&scoped=true&lang=scss"

import exportComponent from "/home/duke/code/duke-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1cd990c"]])

export default __exports__